import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";

const publicRoutes = [
  { path: "login", element: <Login /> },
  { path: "logout", element: <Logout /> },
];

export default publicRoutes;
